import { UIView, YES } from "uicore-ts"
import { RHUserNameComponents } from "../../Core/RHUserName"
import { RHTextField } from "./RHTextField"
import { RHForms, RHSpacing } from "./Utils_slop/RHDesignTokens"


export class RHUserNameInputView extends UIView {

    readonly firstNameTextField = new RHTextField().configuredWithObject({
        placeholderText: "Eesnimi",
        isRequired: YES,
        controlEventTargetAccumulator: {
            EnterDown: () => this.lastNameTextField.focus()
        }
    }).addedAsSubviewToView(this)

    readonly lastNameTextField = new RHTextField().configuredWithObject({
        placeholderText: "Perekonnanimi",
        isRequired: YES
    }).addedAsSubviewToView(this)


    get nameComponents(): RHUserNameComponents {
        return {
            firstName: this.firstNameTextField.text.trim(),
            lastName: this.lastNameTextField.text.trim()
        }
    }


    set nameComponents(nameComponents: RHUserNameComponents) {
        this.firstNameTextField.text = nameComponents.firstName
        this.lastNameTextField.text = nameComponents.lastName
    }


    override layoutSubviews() {
        super.layoutSubviews()

        this.contentBoundsWithInset(0)
            .rectangleWithHeight(RHForms.fieldSingleLineFieldHeight)
            .assignedAsFrameOfView(this.firstNameTextField)
            .rectangleForNextRow(RHSpacing.small, RHForms.fieldSingleLineFieldHeight)
            .assignedAsFrameOfView(this.lastNameTextField)
    }

}
